<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
        <!--        <el-col :span="4" style="height: 100%;">-->
        <!--          <tree-organize ref="org" :treeObj="treeObj" @getOrgArr="getOrgArr"></tree-organize>-->
        <!--        </el-col>-->
        <el-col :span="24" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px;">
              <el-button type="primary" plain icon="el-icon-plus" @click="openAddGoods()">新建代管物品</el-button>
              <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
              </el-date-picker>
              <el-select v-fixZoom v-model="goodsStatus" placeholder="请选择" style="width: 130px">
                <el-option v-for="item in goodsStatusArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button type="success" @click="getSearchData">查询</el-button>
            </div>
            <div style="height: calc(100% - 100px)">
              <el-table :data="tableData" border highlight-current-row height="100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="person_name"
                  label="老人姓名"
                  min-width="120"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="所在床位"
                  min-width="120"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getBedDesc(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="代管物品"
                  min-width="120"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="goods_count"
                  label="数量"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="开始时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.begin_time}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="结束时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.end_time}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="物品状态"
                  width="120"
                  align="center">
                  <template slot-scope="scope">
                    <div :style="{backgroundColor: scope.row.goods_status !== 2 ? 'green' : 'red', color: '#ffffff'}">
                      {{scope.row.goods_status !== 2 ? '正在存放' : '已经取回'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="100">
                  <template slot-scope="scope">
<!--                    <el-button size="mini" type="primary" plain @click="openEditGoods(scope.row)">修改</el-button>-->
                    <el-button :disabled="scope.row.goods_status === 2" size="mini" type="primary" plain @click="takeOutGoods(scope.row)">取出</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                             layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-goods-escrow v-model="addEditShow" :goodsObj="goodsObj" @updateTable="updateTable"></add-edit-goods-escrow>
    </el-dialog>
  </div>
</template>

<script>
import {querygoodsperson, updategoodsperson} from '../../api/yanglaoyuan/goodsperson'
import addEditGoodsEscrow from './components/addEditGoodsEscrow'

export default {
  name: 'goodsEscrow',
  components: {addEditGoodsEscrow},
  data () {
    return {
      entityId: 0,
      espId: 0,
      espName: '',
      sendDate: [],
      goodsStatus: 0,
      goodsStatusArr: [{id: 0, name: '全部'}, {id: 1, name: '正在存放'}, {id: 2, name: '已经取回'}],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],
      addEditShow: false,
      titleShow: '',
      goodsObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.espId = loginResp.syspersonid
    this.espName = loginResp.personname
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let start = new Date().format('yyyy-MM-dd')
    const end = this.commonType.GetDateStr(30)
    this.sendDate = [start, end.format('yyyy-MM-dd')]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },

    openAddGoods () {
      this.titleShow = '新建代管物品'
      this.goodsObj.row = ''
      this.goodsObj.openType = 1
      this.addEditShow = true
    },
    openEditGoods (row) {
      this.titleShow = '修改代管物品'
      this.goodsObj.row = row
      this.goodsObj.openType = 2
      this.addEditShow = true
    },
    takeOutGoods (row) {
      this.$confirm('此操作将取出该代管物品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = row
        data.goods_status = 2
        updategoodsperson(data).then(res => {
          this.$notify({title: '成功', message: '成功取出代管物品', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },
    getSearchData () {
      this.getGoodsPersonData()
    },
    updateTable () {
      this.getGoodsPersonData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // 访问接口
    // 查询代管物品
    getGoodsPersonData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        e_id: this.entityId,
        goods_status: this.goodsStatus,
        from: this.sendDate[0] + ' 00:00:00',
        to: this.sendDate[1] + ' 23:59:59'
      }
      querygoodsperson(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.goods
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/goodsEscrow.vue